import { Person } from "./types";
import { Area } from "../../useAreas/areas/types";

const data: Person = {
  id: "helena-kohlmann",
  firstname: "Helena",
  lastname: "Kohlmann",
  title: "Rechtsanwältin",
  description: "",
  areas: [Area.MIETUNDWOHNUNGSEIGENTUMSRECHT, Area.VERKEHRSRECHT],
  subAreas: [Area.MIETUNDWOHNUNGSEIGENTUMSRECHT, Area.VERKEHRSRECHT],
  phone: "030 / 75 79 64 0",
  mail: "helena.kohlmann@wilms.eu",
  location: "",
  vita: [
    "Geboren 1995 in Berlin",
    "Studium in Potsdam",
    "Referendariat beim Kammergericht Berlin",
    "Rechtsanwältin seit 2024",
  ],
};

export default data;
